export default __webpack_public_path__ + "static/media/sort-down-solid.1a0fbaf9.svg";